import { CAT_STORIES, DOG_STORIES } from '@/components/pet/Reviews/defaultStories';
import StoriesCarousel from '@/components/pet/Reviews/StoriesCarousel';
import type { Story } from '@/components/pet/Reviews/StoryCard';
import { adjustContentVisibility, Section, SectionParagraph } from '@/components/shared/Content';
import starsConfiguration from '@/static/pet/stars.json';
import { Box, Flex, themedColor, useLottie } from '@lemonade-hq/cdk';
import { MEDIA_QUERIES } from '@lemonade-hq/nuis';
import type React from 'react';
import { useRef } from 'react';
import styled from 'styled-components';
import { SectionSubtitle, SectionTitlePet } from './StyledElements';

const DOG_STORIES_SHUFFLED = DOG_STORIES.slice(0, 8);
const CAT_STORIES_SHUFFLED = CAT_STORIES.slice(0, 8);

const STORIES: Story[] = [];
for (let i = 0; i < Math.max(DOG_STORIES_SHUFFLED.length, CAT_STORIES_SHUFFLED.length); i += 2) {
  STORIES.push(...DOG_STORIES_SHUFFLED.slice(i, i + 1));
  STORIES.push(...CAT_STORIES_SHUFFLED.slice(i, i + 1));
}

const StyledSection = styled(Section)`
  ${MEDIA_QUERIES.tabletAndDesktop`
        height: 813px;
        background: ${themedColor('cloud')};
    `}
  ${adjustContentVisibility};
`;

const Stars = styled(Flex)`
  width: 330px;
  height: 68px;

  ${MEDIA_QUERIES.tabletAndDesktop`
        width: 792px;
        height: 155px
    `}
`;

const Title = styled(SectionTitlePet)`
  white-space: pre;
  ${MEDIA_QUERIES.tabletAndDesktop`
    white-space: pre-line;
  `}
  ${MEDIA_QUERIES.mobile`
        padding: 0 1rem;
        white-space: wrap;
  `}
`;

const StarsSection = () => {
  const starsRef = useRef(null);

  useLottie(starsRef, {
    animationData: starsConfiguration,
    lottieConfig: {
      loop: false,
    },
    scrollOptions: {
      playTrigger: {
        threshold: 0.3,
        condition: 'contain',
        pauseIfConditionsUnmet: true,
      },
    },
  });
  return <Stars ref={starsRef} m={['0px 22px 24px', '0px 22px 91px']} />;
};

interface ReviewsProps {
  title?: string;
  subtitle?: string;
}

export const Reviews: React.FC<ReviewsProps> = ({
  title = 'America’s top-rated insurance\nfor dogs, cats, puppies, and kittens',
  subtitle = 'Lemonade has earned 4.9 stars in the App store, and is\nalso top-rated by Supermoney, Clearsurance, and others',
}) => {
  return (
    <StyledSection pt={[50, 90]} darkBackground>
      <Title tabIndex={0}>{title}</Title>
      <SectionSubtitle px={20}>
        <SectionParagraph tabIndex={0}>{subtitle}</SectionParagraph>
      </SectionSubtitle>
      <Box mt={[-37, 0]} mb={[10, 0]}>
        <StarsSection />
      </Box>
      <Box>
        <StoriesCarousel stories={STORIES} />
      </Box>
    </StyledSection>
  );
};
